<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ใบโอนสินค้า</h4>

          <b-card no-body>
            <b-tabs card>
              <b-tab title="รายการโอนออก" active>
                <div class="row" style="margin: 0px 0px 20px 0px">
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหารายการใบโอนสินค้า จากรหัส หรือสาขาปลายทาง"
                  ></b-form-input>
                  <b-button
                    class="col-5 col-sm-4 col-md-3 ml-3"
                    variant="primary"
                    @click="openTransferOutItemModal()"
                  >
                    <i class="fas fa-plus"></i> เพิ่มรายการใบโอนสินค้า
                  </b-button>
                </div>
                <b-table
                  id="transferOutManageTable"
                  ref="transferOutManageTable"
                  hover
                  small
                  sort-icon-left
                  head-variant="light"
                  sort-by="transferCreationDate"
                  :items="getTransferList.transferOut"
                  :fields="transferOutFields"
                  :filter-function="filterTransferOut"
                  :filter="filter"
                  :sort-desc="true"
                  :responsive="true"
                >
                  <template v-slot:cell(index)="row"
                    >{{ row.index + 1 }}.</template
                  >
                  <template v-slot:cell(transferStatus)="row">
                    <TransferStatusBadge :status="row.item.transferStatus" />
                  </template>
                  <template v-slot:cell(transferCreationDate)="row">{{
                    formatDate(row.item.transferCreationDate)
                  }}</template>

                  <template v-slot:cell(buttons)="row">
                    <b-button-group class="show-when-hovered" size="xs">
                      <b-button variant="outline-secondary">
                        <i
                          class="fas fa-info-circle"
                          @click="openTransferDetailItemModal(row.item)"
                        ></i>
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        @click="deleteTransferOut(row.item)"
                        v-if="row.item.transferStatus === 'PENDING'"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                  </template>
                </b-table>
              </b-tab>
              <b-tab title="รายการรับโอนเข้า">
                <div class="row" style="margin: 0px 0px 20px 0px">
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหารายการใบโอนสินค้า จากรหัส หรือสาขาต้นทาง"
                  ></b-form-input>
                </div>
                <b-table
                  id="transferInManageTable"
                  ref="transferInManageTable"
                  hover
                  small
                  sort-icon-left
                  head-variant="light"
                  sort-by="transferCreationDate"
                  :items="getTransferList.transferIn"
                  :fields="transferInfields"
                  :filter-function="filterTransferIn"
                  :filter="filter"
                  :sort-desc="true"
                  :responsive="true"
                >
                  <template v-slot:cell(index)="row"
                    >{{ row.index + 1 }}.</template
                  >
                  <template v-slot:cell(transferStatus)="row">
                    <TransferStatusBadge :status="row.value" />
                  </template>

                  <template v-slot:cell(transferCreationDate)="row">{{
                    formatDate(row.item.transferCreationDate)
                  }}</template>

                  <template v-slot:cell(buttons)="row">
                    <b-button-group class="show-when-hovered" size="xs">
                      <b-button
                        variant="primary"
                        v-if="row.item.transferStatus === 'PENDING'"
                        @click="
                          openTransferDetailItemModal(
                            row.item,
                            row.item.transferStatus === 'PENDING'
                          )
                        "
                        >ตรวจสอบ</b-button
                      >
                      <b-button
                        variant="outline-secondary"
                        v-if="row.item.transferStatus !== 'PENDING'"
                        @click="openTransferDetailItemModal(row.item)"
                      >
                        <i class="fas fa-info-circle"></i>
                      </b-button>
                    </b-button-group>
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
      <TransferOutItem ref="transferOutItemModal"></TransferOutItem>
      <TransferDetailItem ref="transferDetailItemModal"></TransferDetailItem>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";
import TransferStatusBadge from "@/components/badge/ProductAndStock/TransferStatusBadge.vue";
import TransferOutItem from "@/components/modal/ProductAndStock/Transfer/TransferOutItem.vue";
import TransferDetailItem from "@/components/modal/ProductAndStock/Transfer/TransferDetailItem.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TransferInventory",
  components: {
    Dialog,
    Loading,
    TransferStatusBadge,
    TransferOutItem,
    TransferDetailItem,
  },
  data() {
    return {
      isLoading: false,
      transferOutFields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "transferNo",
          label: "รหัสใบโอนสินค้า",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "transferDestinationBranchName",
          label: "สาขาปลายทาง",
          sortable: true,
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },
        {
          key: "transferStatus",
          label: "สถานะการโอน",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "transferCreationDate",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      transferInfields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "transferNo",
          label: "รหัสใบโอนสินค้า",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "transferSourceBranchName",
          label: "สาขาต้นทาง",
          sortable: true,
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },
        {
          key: "transferStatus",
          label: "สถานะการโอน",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "transferCreationDate",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      filter: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getTransferList: "moduleTransferInventory/getTransferList",
      getProductList: "moduleProductInventory/getProductList",
      getDestinationBranchList:
        "moduleTransferInventory/getDestinationBranchList",
      getBranchInfo: "moduleUser/getBranchInfo",
    }),
  },
  methods: {
    ...mapActions({
      fetchTransferList: "moduleTransferInventory/fetchTransferList",
      fetchProductList: "moduleProductInventory/fetchProductList",
      fetchDestinationBranchList:
        "moduleTransferInventory/fetchDestinationBranchList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.fetchTransferList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),
          this.fetchProductList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),
          this.fetchDestinationBranchList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),
        ]);
      } catch (err) {
        this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    openTransferOutItemModal() {
      this.$refs.transferOutItemModal.show({
        productList: this.getProductList,
        destinationBranchList: this.getDestinationBranchList,
        branchInfo: this.getBranchInfo,
      });
    },
    deleteTransferOut(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบใบโอนสินค้านี้ ?",
        "คุณต้องการลบใบโอนสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;
        this.$store
          .dispatch("moduleTransferInventory/deleteTransferOutItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.transferId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการใบโอนสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการใบโอนสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    openTransferDetailItemModal(eventData, isPending) {
      this.isLoading = true;
      this.$store
        .dispatch("moduleTransferInventory/getTransferDetailById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: eventData.transferId,
        })
        .then(res => {
          this.$refs.transferDetailItemModal.show({
            transferDetail: res,
            isTransferInAction: isPending,
          });
        })
        .catch(err => {
          console.error("getTransferDetailById failed", err);
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterTransferOut(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const no = (row.transferNo || "").toString().toLowerCase();
      const branch = (row.transferDestinationBranchName || "")
        .toString()
        .toLowerCase();
      return no.includes(s) || branch.includes(s);
    },
    filterTransferIn(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const no = (row.transferNo || "").toString().toLowerCase();
      const branch = (row.transferSourceBranchName || "")
        .toString()
        .toLowerCase();
      return no.includes(s) || branch.includes(s);
    },
  },
};
</script>

<style scoped>
::v-deep #transferOutManageTable thead tr th,
::v-deep #transferOutManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #transferOutManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #transferOutManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #transferInManageTable thead tr th,
::v-deep #transferInManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #transferInManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #transferInManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}
</style>
